import React, { useState } from "react";
import "./Academia.css";

const FAQ = () => {
   const [activeIndex, setActiveIndex] = useState();

   const questions = [
      {
         q: "¿NECESITO TENER MI PROPIO DRON PARA EMPEZAR?",
         a: "No es necesario. Si lo que buscas es asesoría de compra, te ayudaré a elegir el mejor kit según tu presupuesto antes de que gastes un solo euro.",
      },
      {
         q: "¿ES MUY DIFÍCIL APRENDER A VOLAR FPV?",
         a: "La curva de aprendizaje es real, pero con el método adecuado y práctica en simulador, reducimos los meses de frustración a unas pocas sesiones guiadas.",
      },
      {
         q: "¿QUÉ INCLUYE EL TALLER DE CONFIGURACIÓN?",
         a: "Configuración completa de Betaflight, bindeo de emisora, ajuste de PIDs para vuelo cinemático y comprobación de sistemas de seguridad (Failsafe).",
      },
      {
         q: "¿HACES CLASES FUERA DE MALLORCA?",
         a: "Actualmente las clases presenciales son en Mallorca, pero ofrezco consultoría y soporte de configuración de forma remota a todo el mundo.",
      },
      {
         q: "¿CUÁNTO TIEMPO SE TARDA EN HACER UN VUELO CINEMÁTICO?",
         a: "Depende de tu habilidad previa, pero mi objetivo es que tras el curso tengas la confianza técnica para realizar tomas fluidas y seguras.",
      },
   ];

   return (
      <section className="faq-section">
         <div className="faq-header">
            <h2 className="faq-title">DESPEJA TUS DUDAS</h2>
            <p className="faq-subtitle">
               Anticípate a los problemas y resuelve tus inquietudes antes de
               despegar con Joan Company.
            </p>
         </div>

         <div className="faq-container">
            <div className="faq-badge">PREGUNTAS FRECUENTES</div>
            <div className="faq-list">
               {questions.map((item, index) => (
                  <div
                     key={index}
                     className={`faq-item ${
                        activeIndex === index ? "active" : ""
                     }`}
                     onClick={() =>
                        setActiveIndex(activeIndex === index ? null : index)
                     }
                  >
                     <div className="faq-question">
                        <span>{item.q}</span>
                        <span className="faq-icon">
                           {activeIndex === index ? "˄" : "˅"}
                        </span>
                     </div>
                     {activeIndex === index && (
                        <div className="faq-answer">
                           <div className="answer-line"></div>
                           <p>{item.a}</p>
                        </div>
                     )}
                  </div>
               ))}
            </div>
         </div>
      </section>
   );
};

export default FAQ;
